import styled from 'styled-components'

export const FromRadioWrapper = styled.div`
  display: flex;
  flex-direction: wrap;
`

export const RadioLabel = styled.label`
  display: block;
  margin-right: 15px;
`

export const RadioButton = styled.input``;

export const RadioText = styled.div`
  position: relative;
  padding-left: 30px;
  font-size: 14px;
  line-height: 24px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.greyishBrown};
  min-height: 24px;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: solid 2px ${({ theme }) => theme.brownGrey};
    transition: all 0.3s;
  }
  &:after {
    content: '';
    position: absolute;
    top: 6px;
    left: 6px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${({ theme }) => theme.grassyGreen};
    opacity: 0;
    transition: opacity 0.3s;
  }
  ${RadioButton}:checked + & {
    &:before {
      border: solid 2px ${ ({ theme }) => theme.grassyGreen50};
    }
    &:after {
      opacity: 1;
    }
  }
`